<template>
  <v-dialog max-width="500" persistent scrollable v-model="isOpenDialer">
    <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Marcar
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text class="mb-5">
            <v-form>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="número"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="phoneSelected"
                      :items="phoneList"
                      :error-messages="errors"
                      placeholder="Número a marcar"
                      filled
                      rounded
                    ></v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Llamar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
export default {
  components: { vuescroll },
  props: {
    isOpenDialer: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
    onSubmit: {
      type: Function,
    },
  },
  data() {
    return {
      isLoading: false,
      phoneSelected: null,
      phoneList: [],
    };
  },
  created() {
    this.fillPhoneList();
  },
  methods: {
    fillPhoneList() {
      for (const key in this.item)
        if (key.includes("telefono") && Boolean(Number(this.item[key])))
          this.phoneList = [...this.phoneList, this.item[key]];
    },
    submitForm() {
      this.onSubmit(this.phoneSelected, item.id);
    },
    closeDialog() {
      this.$emit("dialog:change");
    },
  },
};
</script>

<style></style>
